// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  font-family: 'Arial', sans-serif;
}

.hero-section {
  background-color: #1a365d;
  color: white;
  padding: 100px 20px;
  margin-bottom: 50px;
}

.hero-section h1 {
  font-size: 3.5rem;
  margin: 0;
  padding-bottom: 20px;
}

.tagline {
  font-size: 1.5rem;
  margin: 0;
  opacity: 0.9;
}

.intro-section {
  max-width: 800px;
  margin: 0 auto 50px;
  padding: 0 20px;
  line-height: 1.6;
  font-size: 1.2rem;
  color: #333;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.service-card {
  background: white;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.service-card:hover {
  transform: translateY(-5px);
}

.service-card h2 {
  color: #1a365d;
  font-size: 1.5rem;
  margin-bottom: 15px;
}

.service-card p {
  color: #666;
  line-height: 1.5;
  margin: 0;
}

@media (max-width: 768px) {
  .hero-section h1 {
    font-size: 2.5rem;
  }
  
  .tagline {
    font-size: 1.2rem;
  }
  
  .intro-section {
    font-size: 1.1rem;
  }
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".App {\n  text-align: center;\n  font-family: 'Arial', sans-serif;\n}\n\n.hero-section {\n  background-color: #1a365d;\n  color: white;\n  padding: 100px 20px;\n  margin-bottom: 50px;\n}\n\n.hero-section h1 {\n  font-size: 3.5rem;\n  margin: 0;\n  padding-bottom: 20px;\n}\n\n.tagline {\n  font-size: 1.5rem;\n  margin: 0;\n  opacity: 0.9;\n}\n\n.intro-section {\n  max-width: 800px;\n  margin: 0 auto 50px;\n  padding: 0 20px;\n  line-height: 1.6;\n  font-size: 1.2rem;\n  color: #333;\n}\n\n.services-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 30px;\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.service-card {\n  background: white;\n  border-radius: 10px;\n  padding: 30px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease;\n}\n\n.service-card:hover {\n  transform: translateY(-5px);\n}\n\n.service-card h2 {\n  color: #1a365d;\n  font-size: 1.5rem;\n  margin-bottom: 15px;\n}\n\n.service-card p {\n  color: #666;\n  line-height: 1.5;\n  margin: 0;\n}\n\n@media (max-width: 768px) {\n  .hero-section h1 {\n    font-size: 2.5rem;\n  }\n  \n  .tagline {\n    font-size: 1.2rem;\n  }\n  \n  .intro-section {\n    font-size: 1.1rem;\n  }\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
